"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesStatsMulti = exports.EventWarnings = void 0;
const event_warnings_gql_1 = __importDefault(require("./event-warnings.gql"));
exports.EventWarnings = event_warnings_gql_1.default;
const roles_stats_multi_gql_1 = __importDefault(require("./roles-stats-multi.gql"));
exports.RolesStatsMulti = roles_stats_multi_gql_1.default;
